import {TrackInterface} from '@zzng/common/utils/tiara';

import DefaultFooter, {FooterLabel} from '@/shared/components/Footer/DefaultFooter';
import DesktopFooter from '@/shared/components/Footer/DesktopFooter';
import SimpleFooter from '@/shared/components/Footer/SimpleFooter';

export interface FooterProps {
  type: 'default' | 'simple' | 'desktop';
  invisibleLabels?: FooterLabel[];
  trackEvent: (tiara: TrackInterface) => void;
}

const Footer = ({type, ...props}: FooterProps) => {
  if (type === 'simple') return <SimpleFooter {...props} />;
  if (type === 'desktop') return <DesktopFooter {...props} />;
  return <DefaultFooter {...props} />;
};

export default Footer;
